import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetUsers = z.any()
export type TagsGetUsers = z.infer<typeof tagsGetUsers>

export const descriptionGetUsers = z.any()
export type DescriptionGetUsers = z.infer<typeof descriptionGetUsers>

export const querystringGetUsers = z.object({ "page": z.string().optional(), "perPage": z.string().optional() })
export type QuerystringGetUsers = z.infer<typeof querystringGetUsers>

export const responseGetUsers = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "name": z.string(), "email": z.string(), "createdAt": z.string(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "primaryAccount": z.boolean(), "role": z.union([z.literal("READ_ONLY"), z.literal("INVOICE_EDITOR"), z.literal("POWER_USER")]), "buildingIds": z.array(z.string().uuid()) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetUsers = z.infer<typeof responseGetUsers>

interface IGetUsers extends BaseMethodType {
  tags: TagsGetUsers,
  description: DescriptionGetUsers,
  querystring: QuerystringGetUsers,
  response: ResponseGetUsers
}
export const tagsPostUsers = z.any()
export type TagsPostUsers = z.infer<typeof tagsPostUsers>

export const descriptionPostUsers = z.any()
export type DescriptionPostUsers = z.infer<typeof descriptionPostUsers>

export const bodyPostUsers = z.object({ "name": z.string().min(1), "email": z.string().email(), "role": z.union([z.literal("READ_ONLY"), z.literal("INVOICE_EDITOR"), z.literal("POWER_USER")]).optional(), "buildingIds": z.array(z.string().uuid()).optional() })
export type BodyPostUsers = z.infer<typeof bodyPostUsers>

export const responsePostUsers = z.object({ "payload": z.object({ "id": z.string().uuid(), "name": z.string(), "email": z.string(), "createdAt": z.string(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean(), "primaryAccount": z.boolean(), "role": z.union([z.literal("READ_ONLY"), z.literal("INVOICE_EDITOR"), z.literal("POWER_USER")]), "buildingIds": z.array(z.string().uuid()) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostUsers = z.infer<typeof responsePostUsers>

interface IPostUsers extends BaseMethodType {
  tags: TagsPostUsers,
  description: DescriptionPostUsers,
  body: BodyPostUsers,
  response: ResponsePostUsers
}
export const URL = '/users'
export const validation = {
  get: {
    tags: tagsGetUsers,
    description: descriptionGetUsers,
    querystring: querystringGetUsers,
    response: responseGetUsers
  },
  post: {
    tags: tagsPostUsers,
    description: descriptionPostUsers,
    body: bodyPostUsers,
    response: responsePostUsers
  }
}
export interface Users extends BaseRouteType {
  get: IGetUsers,
  post: IPostUsers
}